import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { FormItemTypes } from '@bimser/core';
import { Plugins } from '@bimser/studio-core';
import { MainState } from '@bimser/studio-core/dist/studioState';
import { Map } from 'immutable';

export function getPreviewFormItems(
	state: MainState,
	windowId: string
): Map<string, LayoutCreatorEntities.LayoutItem> {
	const formDesignerPlugin = state.plugins.get(Plugins.FlowLayout.Constants.PluginId);
	if (formDesignerPlugin?.windows) {
		const window = formDesignerPlugin.windows.get(windowId);
		const data: Map<string, LayoutCreatorEntities.LayoutDataItem> = window?.contentData?.data;
		const view: LayoutCreatorEntities.NormalizedLayoutStructureItems =
			window?.contentData?.views.get(window.contentData.activeView);
		return mergeViewItems(data, view);
	}
}

function mergeViewItems(
	data: Map<string, LayoutCreatorEntities.LayoutDataItem>,
	view: LayoutCreatorEntities.NormalizedLayoutStructureItems
): Map<string, LayoutCreatorEntities.LayoutItem> {
	if (view && data && !data.isEmpty() && !view.result.isEmpty()) {
		let items: LayoutCreatorEntities.NormalizedLayoutItems =
			LayoutCreatorEntities.NormalizedLayoutItemsFactory();
		view.entities.items.forEach(item => {
			let newItem = item;
			if (
				FormItemTypes.EControlTypes[item.type as FormItemTypes.EControlTypes] ||
				item.type === FormItemTypes.EContainerTypes.Form
			) {
				newItem = LayoutCreatorEntities.LayoutItemFactoryFromJS({
					...item.toJS(),
					properties: data.get(item.id)?.properties?.toJS()
				}) as LayoutCreatorEntities.LayoutStructureItem;
			}
			const newItems = items.entities.items.set(item.id, newItem);
			const newEntities = items.entities.set('items', newItems);
			items = items.set('entities', newEntities);
		});
		items = items.set('result', view.result);
		return items.entities.items;
	} else {
		return LayoutCreatorEntities.NormalizedLayoutItemsFactory().entities.items;
	}
}
